module.exports = __webpack_public_path__ + "static/media/bgHubungiKami.409a8b7c.jpg";